import { createActionTypes } from "utils/action/actionTypes";

export const FETCH_COCAPEX_LIST = createActionTypes('FETCH_COCAPEX_LIST');
export const ADD_COCAPEX_LIST_ITEM = createActionTypes('ADD_COCAPEX_LIST_ITEM');
export const DELETE_COCAPEX_LIST_ITEM = createActionTypes('DELETE_COCAPEX_LIST_ITEM');
export const UPDATE_COCAPEX_LIST_ITEM = createActionTypes('UPDATE_COCAPEX_LIST_ITEM');